import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import Regi from "./pages/Regi";
import List from "./pages/List";
import logo from "../src/assets/GON-logo1.png";

function Home() {
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState(30 * 60);
  const inactivityTimerRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const navigate = useNavigate();

  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
    }

    setTimeRemaining(30 * 60);

    inactivityTimerRef.current = setTimeout(
      () => {
        handleAutoLogout();
      },
      30 * 60 * 1000,
    );

    countdownIntervalRef.current = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(countdownIntervalRef.current);
          handleAutoLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, []);

  const handleAutoLogout = () => {
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
    }

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userType");
    localStorage.removeItem("loginType");
    alert("Session expired due to inactivity. Please login again.");
    navigate("/login");
  };

  const handleLogout = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
    }

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userType");
    localStorage.removeItem("loginType");
    navigate("/login");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    const storedUserType = localStorage.getItem("userType");
    const storedLoginType = localStorage.getItem("loginType");

    if (!token || !storedUser) {
      navigate("/login");
      return;
    }

    try {
      setUser(JSON.parse(storedUser));
      setUserType(storedLoginType || storedUserType || "user");
      setIsLoading(false);

      resetInactivityTimer();
    } catch (error) {
      console.error("Error parsing user data:", error);
      localStorage.clear();
      navigate("/login");
    }

    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, [navigate, resetInactivityTimer]);

  useEffect(() => {
    if (!isLoading) {
      const events = [
        "mousedown",
        "keydown",
        "scroll",
        "touchstart",
        "mousemove",
      ];

      const handleUserActivity = () => {
        resetInactivityTimer();
      };

      events.forEach((event) => {
        window.addEventListener(event, handleUserActivity);
      });

      return () => {
        events.forEach((event) => {
          window.removeEventListener(event, handleUserActivity);
        });
      };
    }
  }, [isLoading, resetInactivityTimer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  if (isLoading) {
    return (
      <div className="home-loading">
        <div className="loading-spinner"></div>
        <p>Loading your dashboard...</p>
      </div>
    );
  }

  return (
    <div className="home-container">
      <header className="home-header">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo-icon">
              <img src={logo} alt="Logo" className="logo-img" />
            </div>
            <div className="logo-text">
              <h1 className="app-title">SPEAR</h1>
              <p className="app-subtitle">CS Admin Hub</p>
            </div>
          </div>

          <div className="user-section">
            {/* <div className="session-timer">
              <span className="timer-text">
                Session expires in: {formatTime(timeRemaining)}
              </span>
            </div> */}
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="home-main">
        <Regi />
        <List />
      </main>
    </div>
  );
}

export default Home;
